"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AButton = exports.IconButton = exports.Button = void 0;
const React = __importStar(require("react"));
function cx(...items) {
    const ret = items.reduce((acc, x) => {
        if (!x)
            return acc;
        acc.push(...x.split(' '));
        return acc;
    }, []);
    return ret.join(' ');
}
const Button = (props) => {
    const { bg = 'light', kind = 'primary', presetColor = 'blue', large, leftIcon, rightIcon, children, disabled, as, className } = props, buttonOrLinkProps = __rest(props, ["bg", "kind", "presetColor", "large", "leftIcon", "rightIcon", "children", "disabled", "as", "className"]);
    const fixedContent = typeof children === 'string' ? (React.createElement("span", { className: "bn-button-content bn-button-fixed-font-content" }, children)) : (React.createElement("span", { className: "bn-button-content" }, children));
    const content = (React.createElement(React.Fragment, null,
        leftIcon,
        fixedContent,
        rightIcon));
    const iconButton = leftIcon && !children && !rightIcon ? 'bn-icon' : '';
    const bigBoi = large && !iconButton ? 'bn-large' : 'bn-normal';
    const disabledLink = as === 'link' && disabled ? 'bn-disabled' : '';
    const klass = cx(`bn-${kind} bn-${presetColor} bn-${bg}`, bigBoi, disabledLink, iconButton, className);
    if (as === 'submit') {
        return (React.createElement("button", Object.assign({}, buttonOrLinkProps, { className: klass, disabled: disabled }), content));
    }
    else if (as === 'link') {
        return (React.createElement("a", Object.assign({}, buttonOrLinkProps, { className: klass }), content));
    }
    throw new Error("Unknown or unset 'as' prop!");
};
exports.Button = Button;
const IconButton = (_a) => {
    var { icon } = _a, others = __rest(_a, ["icon"]);
    return (React.createElement(exports.Button, Object.assign({ leftIcon: icon }, others)));
};
exports.IconButton = IconButton;
const AaronTypeToButtonColor = {
    cta: 'pink',
    ctaTheme2: 'pink',
    ctaAdvanced: 'pink',
    danger: 'red',
};
const AaronFillToKind = {
    solid: 'primary',
    outline: 'secondary',
    inverse: 'tertiary',
};
const AaronSizeToHeightOverride = {
    tiny: 22,
    small: 28,
};
class AButton extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            disabled: false,
        };
        this.disableOnClick = () => {
            typeof this.props.disableWith !== 'undefined' &&
                this.setState({ disabled: true });
        };
    }
    render() {
        var _a, _b;
        const _c = this.props, { size, type, fill, disableWith, children, onClick, as } = _c, others = __rest(_c, ["size", "type", "fill", "disableWith", "children", "onClick", "as"]);
        const { disabled } = this.state;
        let presetColor = type ? (_a = AaronTypeToButtonColor[type]) !== null && _a !== void 0 ? _a : 'blue' : 'blue';
        const kind = (_b = AaronFillToKind[fill !== null && fill !== void 0 ? fill : 'solid']) !== null && _b !== void 0 ? _b : 'primary';
        const sizeOverride = size && AaronSizeToHeightOverride[size]
            ? { minHeight: AaronSizeToHeightOverride[size] }
            : {};
        const isLarge = size === 'large';
        if (as === 'a' || others.href) {
            return (React.createElement(exports.Button, Object.assign({ as: "link", style: sizeOverride, large: isLarge, kind: kind, href: this.props.href, presetColor: presetColor, bg: fill === 'inverse' ? 'dark' : 'light', onClick: (e) => {
                    this.disableOnClick();
                    onClick && onClick(e);
                }, disabled: disabled }, others), disabled ? disableWith || children : children));
        }
        else {
            return (React.createElement(exports.Button, Object.assign({ as: "submit", style: sizeOverride, large: isLarge, kind: kind, presetColor: presetColor, bg: fill === 'inverse' ? 'dark' : 'light', onClick: (e) => {
                    this.disableOnClick();
                    onClick && onClick(e);
                }, disabled: disabled }, others), disabled ? disableWith || children : children));
        }
    }
}
exports.AButton = AButton;
//# sourceMappingURL=buttons.js.map